import { i18n } from '~/utils';

export const CONCRETE_TYPES = {
  ATC: i18n.t(($) => $.aiParserReview.form.lineItem.concrete.type.options.ATC),
  M: i18n.t(($) => $.aiParserReview.form.lineItem.concrete.type.options.M),
  MIX: i18n.t(($) => $.aiParserReview.form.lineItem.concrete.type.options.MIX),
  STD: i18n.t(($) => $.aiParserReview.form.lineItem.concrete.type.options.STD),
};

export const CONCRETE_COMPONENT_TYPES = {
  AC: i18n.t(
    ($) => $.aiParserReview.form.lineItem.concrete.component.type.options.AC,
  ),
  AD: i18n.t(
    ($) => $.aiParserReview.form.lineItem.concrete.component.type.options.AD,
  ),
  CE: i18n.t(
    ($) => $.aiParserReview.form.lineItem.concrete.component.type.options.CE,
  ),
  CP: i18n.t(
    ($) => $.aiParserReview.form.lineItem.concrete.component.type.options.CP,
  ),
  DP: i18n.t(
    ($) => $.aiParserReview.form.lineItem.concrete.component.type.options.DP,
  ),
  GF: i18n.t(
    ($) => $.aiParserReview.form.lineItem.concrete.component.type.options.GF,
  ),
  OA: i18n.t(
    ($) => $.aiParserReview.form.lineItem.concrete.component.type.options.OA,
  ),
  OM: i18n.t(
    ($) => $.aiParserReview.form.lineItem.concrete.component.type.options.OM,
  ),
  PZ: i18n.t(
    ($) => $.aiParserReview.form.lineItem.concrete.component.type.options.PZ,
  ),
  RT: i18n.t(
    ($) => $.aiParserReview.form.lineItem.concrete.component.type.options.RT,
  ),
  SP: i18n.t(
    ($) => $.aiParserReview.form.lineItem.concrete.component.type.options.SP,
  ),
  WR: i18n.t(
    ($) => $.aiParserReview.form.lineItem.concrete.component.type.options.WR,
  ),
  WT: i18n.t(
    ($) => $.aiParserReview.form.lineItem.concrete.component.type.options.WT,
  ),
};
